document.addEventListener('DOMContentLoaded', function () {
  const observer = new MutationObserver(() => {
    const closeButton = document.querySelector('[id^="form-container-ref"] [class*="Close"]');
    if (closeButton && !closeButton.dataset.listenerAdded) {
      closeButton.dataset.listenerAdded = 'true';

      const closeModal = () => {
        const modal = document.querySelector('[id^="form-container-ref"]');
        if (modal) {
          modal.style.display = 'none';
          console.log('📱 Modal cerrado desde celular');
        }
      };

      closeButton.addEventListener('click', closeModal);
      closeButton.addEventListener('touchend', function (e) {
        e.preventDefault();
        e.stopPropagation();
        closeModal();
      });

      console.log('✅ Eventos agregados al botón cerrar');
    }
  });

  observer.observe(document.body, { childList: true, subtree: true });
});

(function injectCSS() {
  const style = document.createElement('style');
  style.innerHTML = `
    [class*="Close"], [class*="close"], [class*="closeButton"] {
      z-index: 9999 !important;
      pointer-events: auto !important;
      cursor: pointer !important;
      touch-action: manipulation !important;
      position: relative !important;
    }
  `;
  document.head.appendChild(style);
})();

document.body.querySelectorAll('*').forEach(el => {
  el.style.outline = '1px solid red';
});

